// @flow

import * as React from 'react';
import { Helmet } from 'react-helmet';

export const Title = (props: {
  title: string,
  section?: string,
  description?: string,
  thumbnailUrl?: string,
  name?: string,
}) => (
  <Helmet>
    <title>{props.title} {props.section && `| ${props.section}`}</title>
    {props.description && <meta name="description" content={props.description} />}

    <meta property="og:title" content={props.title} />
    {props.description && <meta property="og:description" content={props.description} />}

    <meta name="twitter:title" content={props.title} />
    {props.description && <meta name="twitter:description" content={props.description} />}

    {/* Facebook social card */}
    <meta property="og:site_name" content={props.name} />
    <meta property="og:type" content="website" />
    <meta property="og:image" content={props.thumbnailUrl} />
  </Helmet>
);
Title.defaultProps = { section: '', description: '' };



// WEBPACK FOOTER //
// ./src/layouts/Title.jsx